import React from "react";
import UseLang from "../../../hooks/UseLang";

function RFC8950Preview() {
  return (
    <>
      <div class="alerts alert_white">
         <UseLang es>
         <h1>Implementación del RFC8950 para la transición a IPv6-only: soporte de IPv4aaS en redes MikroTik</h1>
          <p>
            <strong> Autor:</strong> José Cotúa, Director General de SIMEON COMPANY CHILE SPA
          </p>
          
          <p>
            <strong>Fecha:</strong> Septiembre 2025
          </p>
         
          <a
            href="/es/ipv6/implementacion-del-rfc8950-para-la-transicion-a-ipv6-only-soporte-de-ipv4aas-en-redes-mikrotik"
            class="buttons button_blue" 
          >
            Leer Reporte
          </a>
         </UseLang>
         <UseLang en>
         <h1>Implementing RFC8950 for Transitioning to IPv6 Only: IPv4aaS Support in Mikrotik Networks</h1>
          <p>
            <strong> Author:</strong> José Cotúa, CEO of SIMEON COMPANY CHILE SPA
          </p>
          
          <p>
            <strong>Fecha:</strong> Septiembre 2025
          </p>
         
          <a
            href="/en/ipv6/implementing-rfc8950-for-transitioning-to-ipv6-only-ipv4aas-support-in-mikrotik-networks"
            class="buttons button_blue" 
          >
            Read Report
          </a>
         </UseLang>
         <UseLang pt>
         <h1>Implementação do RFC8950 para a transição para só IPv6: Suporte do IPv4aaS em Redes MikroTik</h1>
          <p>
            <strong> Autor:</strong> José Cotúa, Director General de SIMEON COMPANY CHILE SPA
          </p>
          
          <p>
            <strong>Data:</strong> Septiembre 2025
          </p>
         
          <a
            href="/pt/ipv6/implementacao-do-rfc8950-para-a-transicao-para-so-ipv6-suporte-do-ipv4aas-em-redes-mikrotik" 
            class="buttons button_blue" >
             Leia o Relatório

          </a>
         </UseLang>
      </div>
    </>
  );
}

export default RFC8950Preview;
